export default "__VITE_ASSET__COrO928y__"